export type ClientLocation = {
  latitude: number
  longitude: number
}

export const getClientLocation = async (): Promise<ClientLocation | undefined> => {
  if (!window.navigator?.permissions) {
    return
  }

  const permissionStatus = await window.navigator.permissions.query({
    name: 'geolocation',
  })

  if (permissionStatus) {
    if (permissionStatus.state === 'granted') {
      return new Promise<ClientLocation>((resolve, reject) => {
        window.navigator.geolocation.getCurrentPosition(
          function success(position: GeolocationPosition) {
            resolve({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            })
          },
          function error(error: GeolocationPositionError) {
            reject(error)
          }
        )
      })
    }
  }

  return
}
